import React from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import { FileText, Clock, Megaphone } from 'lucide-react';
import PED from './PED';
import PedStorie from './PedStorie';
import Campagne from './Campagne';

// Contenitore "Piano Editoriale" con tre sezioni: Post e reel, Storie, Campagne.
// La tab attiva è derivata dalla route (/ped vs /ped-storie vs /campagne) così i deep-link restano validi.
const TABS = [
  { key: 'ped',      label: 'Post e reel', to: '/ped',       Icon: FileText },
  { key: 'storie',   label: 'Storie',      to: '/ped-storie', Icon: Clock },
  { key: 'campagne', label: 'Campagne',   to: '/campagne',   Icon: Megaphone },
];

export default function PianoEditoriale() {
  const navigate = useNavigate();
  const { pathname, search } = useLocation();
  const active = pathname.startsWith('/ped-storie') ? 'storie'
    : pathname.startsWith('/campagne') ? 'campagne' : 'ped';

  return (
    <div>
      <div className="eden-page eden-page--tabs eden-scroll-row" role="tablist" aria-label="Sezioni del Piano Editoriale">
        {TABS.map(t => {
          const on = active === t.key;
          // il cliente scelto segue da solo (useClienteAttivo): niente parametri da trascinare
          const dest = t.key === active ? `${t.to}${search}` : t.to;
          return (
            <button key={t.key} onClick={() => navigate(dest)} role="tab" aria-selected={on}
              className={`eden-tabs-item${on ? ' is-active' : ''}`}>
              <t.Icon size={15} />{t.label}
            </button>
          );
        })}
      </div>
      {active === 'storie' ? <PedStorie /> : active === 'campagne' ? <Campagne /> : <PED />}
    </div>
  );
}
